export const VIEW_MODE = {
  AREA_DAY: 1,
  AREA_WEEK: 0,
  AREA_2WEEK: 5,
  AREA_4WEEK: 9,
  AREA_MONTH: 8,
  EMPLOYEE_DAY: 4,
  EMPLOYEE_WEEK: 2,
  EMPLOYEE_2WEEK: 6,
  EMPLOYEE_4WEEK: 7,
  EMPLOYEE_MONTH: 3,
};

export const VIEW_MODE_STEPS = {
  DAY: {
    step: 1,
    maxStep: 56,
  },
  WEEK: {
    step: 7,
    maxStep: 26 * 7,
  },
  TWO_WEEK: {
    step: 14,
    maxStep: 14 * 14,
  },
  FOUR_WEEK: {
    step: 28,
    maxStep: 7 * 28,
  },
};

export const VIEW_MODE_INDEX = {
  0: 'AREA_WEEK',
  1: 'AREA_DAY',
  2: 'EMPLOYEE_WEEK',
  3: 'EMPLOYEE_MONTH',
  4: 'EMPLOYEE_DAY',
  5: 'AREA_2WEEK',
  6: 'EMPLOYEE_2WEEK',
  7: 'EMPLOYEE_4WEEK',
  8: 'AREA_MONTH',
  9: 'AREA_4WEEK',
};

export const DASHBOARD_VIEWS_VIEW_MODE = {
  1: 'AREA_DAY',
  2: 'AREA_WEEK',
  3: 'AREA_2WEEK',
  4: 'AREA_4WEEK',
  5: 'AREA_MONTH',
};

export const CUSTOM_FIELD_TYPES = {
  TEXT: 1,
  NUMBER: 2,
  LARGE_TEXT: 3,
  BOOLEAN_CHECKBOX: 4,
  LIST: 5,
  MULTI_LIST: 6,
  BOOLEAN_WITH_COMMENT: 8,
};

export const CUSTOM_FIELD_VALIDATION_TYPE = {
  NOT_EMPTY: 'nempty',
};

export const PREFERENCE_KEYS = {
  ACTIVE: 'schedule-stats-panel-active',
  STATS_OPEN: 'schedule-stats-open',
  SUBSCRIPTION: 'schedule-stats-panel-subscription',
};

export const SCHEDULE_TOP_BAR_HEIGHT = 56;
export const DAY_HEADER_HEIGHT = 38;
export const STATS_TOGGLE_BAR = 44;
export const FIXED_STATS_HEIGHT = 232;

export const NOTIFY_OPTIONS = {
  sms: 'SMS',
  smsEmailPush: 'SMS_EMAIL_PUSH',
  emailPush: 'EMAIL_PUSH',
  disabled: 'DISABLED',
};

export const NOTIFY_OPTIONS_NAMES = {
  SMS: 'Notify sms and confirmation',
  SMS_EMAIL_PUSH: 'Notify sms, email and push',
  EMAIL_PUSH: 'Notify email and push',
  DISABLED: 'No notification for publish',
};

export const NOTIFY_OPTIONS_NAMES_SMS_OFF = {
  SMS: 'Require confirmation (email and app)',
  EMAIL_PUSH: 'Notify (email, app)',
  DISABLED: 'No notifications (mark as published)',
};

export const METRIC_TYPES = {
  LABOR_PERCENTAGE: 'LaborPercentage',
  SALES_PER_HOUR: 'SalesPerHour',
  STAFF_NUMBER: 'StaffNumber',
  WAGE: 'Wage',
  STAFF: 'Staff',
  STAFF_HOUR: 'StaffHour',
  SALES: 'Sales',
  REQUIRED_STAFF: 'RequiredStaff',
  FORECAST_REQUIRED_STAFF: 'forecast_RequiredStaff',
  AVERAGE_HOURLY_RATE: 'AverageHourlyRate',
};

export const UI_METRIC_TYPES = {
  LABOUR: '__LABOUR__',
  SUMMARY: '__SUMMARY__',
  BUDGET_WAGE: '__BUDGETWAGE__',
  BUDGET_HOUR: '__BUDGETHOUR__',
  RAW_DATA: '__RAW_DATA__',
};

export const LABOR_PERCENTAGE = 'LaborPercentage';
export const SALES_PER_HOUR = 'SalesPerHour';
export const SALES = 'Sales';

export const METRIC_STATES = {
  FORECAST: 'forecast',
  PLAN: 'plan',
  PLAN_HOURLY: 'plan_hourly',
  PLAN_SALARY: 'plan_salary',
  PLAN_LEAVE: 'plan_leave',
  PLAN_SHIFTS: 'plan_shifts',
  PLAN_OPEN_EMPTY: 'plan_open_empty',
  PLAN_OPEN_AREA: 'plan_open_area',
  ACTUAL: 'actual',
  ACTUAL_HOURLY: 'actual_hourly',
  ACTUAL_SALARY: 'actual_salary',
  ACTUAL_LEAVE: 'actual_leave',
  ACTUAL_SHIFTS: 'actual_shifts',
  ACTUAL_AREA: 'actual_area',
  PLAN_ALL: 'plan_all',
  BUDGET: 'budget',
  ACTUAL_NO_LEAVE: 'actual_no_leave',
  PLAN_NO_LEAVE: 'plan_no_leave',
  FORECAST_HOURS: 'forecast_hours',
  ACTUAL_HOURS: 'actual_hours',
  FORECAST_AREA: 'forecast_area',
};

export const VALUE_TYPES = {
  CURRENCY: 'currency',
  UNIT: 'unit',
};

export const BREAK_STATES = {
  NOT_START: 0,
  IN_PROGRESS: 1,
  FINISHED: 2,
  DURATION_ONLY: 3,
};

export const V1_TO_V2_BREAK_STATES = {
  0: 'NOT_START',
  1: 'IN_PROGRESS',
  2: 'FINISHED',
  3: 'DURATION_ONLY',
};

export const BREAK_TYPES_LONG = {
  REST: 'rest',
  MEAL: 'meal',
};

export const UNASSIGNED_SHIFTS = {
  EMPTY: 'empty',
  OPEN: 'open',
  OPEN_WITH_APPROVAL: 'open-with-approval',
  NO_EMPLOYEE: 0,
};

export const OPEN_SHIFT_STATUS = {
  DECLINED: 'DECLINED',
  ACCEPTED: 'ACCEPTED',
};

export const REPEAT_FREQ = {
  TOMORROW: 'tomorrow',
  END_DATE: 'end-date',
  SELECTED_DAYS: 'selected-week-days',
  DAYS_PATTERN: 'days-pattern',
};

export const SHIFT_TYPES = {
  SHIFT: 'shift',
  OTHER_SHIFT: 'otherShift',
  LEAVE: 'leave',
  UNAVAILABILITY: 'unavailability',
  AVAILABILITY: 'availability',
  UNAVAILABILITY_MULTIPLE: 'unavailability_multiple',
  AVAILABILITY_MULTIPLE: 'availability_multiple',
};

export const UNASSIGNED_EMPLOYEE = '0';

export const CONSENT_VIOLATED_RULES = {
  SCHEDULE_RULE_CLOPENING_GAP: 'ScheduleRuleClopeningGap',
};

export const ROSTER_CONFIRM_STATUS = {
  ROSTER_CONFIRM_NOT_REQUIRE: 0,
  ROSTER_CONFIRMATION_NOT_REQUIRED: 0,
  ROSTER_CONFIRM_REQUIRE: 1,
  ROSTER_CONFIRMATION_REQUIRED: 1,
  ROSTER_CONFIRM_DONE: 2,
  ROSTER_CONFIRMATION_DONE: 2,
  ROSTER_CONFIRM_DECLINED: 3,
  ROSTER_CONFIRMATION_DECLINED: 3,
};

export const ROSTER_CONFIRM_STATUS_ENUM = {
  ROSTER_CONFIRMATION_REQUIRED: 'ROSTER_CONFIRMATION_REQUIRED',
};

export const ADD_SHIFT_POPOVER_STATES = {
  CUSTOM_FIELDS_VISIBLE: 'customFieldsVisible',
};

export const ADD_SHIFT_POPOVER_ACTION_KEYS = {
  ESCAPE_KEY: 'Escape',
  TAB_KEY: 'Tab',
  ENTER_KEY: 13,
  BACKSPACE_KEY: 8,
  DELETE_KEY: 46,
  HISTORY_KEY: 72,
  OVERRIDE_KEY: 79,
};

export const LOCALIZED_DATE_TIME_FORMAT = "yyyy-MM-dd'T'TTZZ";

export const WEEK_DAYS_PLURAL = {
  Mon: 'Mondays',
  Tue: 'Tuesdays',
  Wed: 'Wednesdays',
  Thu: 'Thursdays',
  Fri: 'Fridays',
  Sat: 'Saturdays',
  Sun: 'Sundays',
};

export const BULK_UPDATE_SELECTOR_CONSTANTS = Object.freeze({
  NO_CHANGES: 'no-changes',
  EMPLOYEE_EMPTY: 'empty',
  EMPLOYEE_OPEN: 'open',
  EMPLOYEE_OPEN_WITH_APPROVAL: 'open-with-approval',
  NOTE_REPLACE: 'note:replace',
  NOTE_REMOVE: 'note:remove',
  STATUS_PUBLISHED: 'status:published',
  STATUS_UNPUBLISHED: 'status:unpublished',
});

export const VALIDATION_ERROR_CODES = {
  UNAVAILABLE: 'UNAVAILABLE',
  ON_LEAVE: 'ON_LEAVE',
  NOT_TRAINED: 'NOT_TRAINED',
  NOT_PREFERRED: 'NOT_PREFERRED',
  STRESSED: 'STRESSED',
  VIOLATES_SCHEDULE_RULE: 'VIOLATES_SCHEDULE_RULE',
  OVERLAPPING: 'OVERLAPPING',
  INVALID_TIME_RANGE: 'INVALID_TIME_RANGE', // roster time updated in a way that one of the subshifts is eliminated
  BREAK_DURATION_EXCEED: 'BREAK_DURATION_EXCEED', // break duration exceeded roster duration
  COST_OVERTIME: 'COST_OVERTIME', // overtime warning from cost/forecast calculation
  OTHER: 'OTHER',
};

export const DEPUTY_SAVE_VIA_UI = 'Deputy-Save-Via-UI';

export const SHIFT_VALIDATION_FIELD_NAMES = {
  AU_FAST_FOOD_AWARD: 'AU_FAST_FOOD_AWARD',
};

export const BULK_OPERATION_TOASTER = {
  NO_ELIGIBLE_EMPLOYEE: 'No eligible employee',
  RESULT: 'result',
  SENT_COUNT: 'sent-count',
  NOT_SENT_COUNT: 'not-sent-count',
};
